import { CommonModule, NgIf } from '@angular/common'
import { Component } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent, KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS, NumericTextBoxComponent, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'

@Component({
  selector: 'gd-type-editor-states',
  templateUrl: './type-editor-states.component.html',
  styleUrls: ['./type-editor-states.component.scss'],
  imports: [
    CommonModule,
    GridComponent,
    DataBindingDirective,
    ToolbarTemplateDirective,
    GridToolbarFocusableDirective,
    AddCommandDirective,
    ButtonComponent,
    NgIf,
    ColumnComponent,
    EditTemplateDirective,
    TextBoxDirective,
    FormsModule,
    ReactiveFormsModule,
    NumericTextBoxComponent,
    CellTemplateDirective,
    CommandColumnComponent,
    FocusableDirective,
    EditCommandDirective,
    SaveCommandDirective,
    CancelCommandDirective,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS, KENDO_BUTTONS,
  ]
})
export class TypeEditorStatesComponent extends GridEditorBaseComponent {
  public hiderow = false
  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  initGrid(): void {
    this.typesService.getCompleteStatelist().subscribe((response) => {
      this.repState.stateListWithInactive = response
    })
  }

  saveHandler({
    sender,
    rowIndex,
    formGroup,
    isNew,
  }: {
    sender: any
    rowIndex: any
    formGroup: any
    isNew: any
  }): void {
    const state = formGroup.value
    this.typesService.submitStateUpdate(state).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  addHandler({ sender }: { sender: any }) {
    this.addHandlerShared(
      { sender },
      {
        stateId: 0,
        stateValue: null,
        stateText: null,
        bdfees: null,
        iafees: null,
        active: true,
      },
    )
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  createFormGroup(state: any): UntypedFormGroup {
    return this.formBuilder.group({
      stateId: state.stateId,
      stateValue: [state.stateValue, Validators.required],
      stateText: [state.stateText, Validators.required],
      bdfees: [state.bdfees, Validators.required],
      iafees: [state.iafees, Validators.required],
      active: state.active,
    })
  }
  buttonclicked() {
    this.hiderow = true
  }
  showfield() {
    this.hiderow = false
  }
}
